const bodyData = [
  {
    id: 1,
    image: "Media.png",
    title: "Say Anything",
    subTitle:
      "Share text, voice messages, photos, videos, GIFs and files for free. Sohbet uses your phone's data connection so you can avoid SMS and MMS fees",
  },
  {
    id: 2,
    image: "Calls.png",
    title: "Speak Freely",
    subTitle:
      "Make crystal-clear voice and video calls to people who live across town, or across the ocean, with no long-distance charges.",
  },
];

const bodyDataTwo = [
  {
    id: 1,
    image: "Stickers.png",
    title: "Make Privacy Stick",
    subTitle:
      "Add a new layer of expression to your conversations with encrypted stickers. You can also create and share your own sticker packs.",
  },
  {
    id: 2,
    image: "Groups.png",
    title: "Get Together with Groups",
    subTitle:
      "Group chats make it easy to stay connected to your family, friends, and coworkers.",
  },
];

export { bodyData, bodyDataTwo };
